import React from 'react';
import PropTypes from 'prop-types';
import {
  getDefaultCells,
  CROSSTAB_VIEWER_GRID_TYPE,
} from '../../../util/CrosstabUtils';
import CrosstabViewerGridHeadCell from './CrosstabViewerGridHeadCell';

const CrosstabViewerGridHeadRow = ({
  columnDefinitions,
  onSort,
  renderHeadCell,
  cellElementList,
  tableData,
  viewerGridType,
  selectedDropdownColumn,
  horizontalEPP,
  horizontalPageNo,
  selectedKPIsTitle,
  allSelectedKPIsInfo,
}) => {
  const defaultRenderer = (def, cellIndex, columnIndex) => (
    <CrosstabViewerGridHeadCell
      key={`head-${def.sortKey ? def.sortKey : def}-${cellIndex}`}
      {...{
        def,
        cellElementList,
        onSort,
        cellIndex,
        columnIndex,
        viewerGridType,
        selectedDropdownColumn,
        sortOrder: tableData.sortOrder,
        sortKey: tableData.sortKey,
        sortColumnIndex: tableData.sortColumnIndex,
        selectedKPIsTitle,
        allSelectedKPIsInfo,
      }}
    />
  );

  const renderCell = (def, cellIndex, columnIndex) =>
    renderHeadCell
      ? renderHeadCell(defaultRenderer, def, cellIndex, columnIndex)
      : defaultRenderer(def, cellIndex, columnIndex);

  const renderRows = () => {
    if (viewerGridType === CROSSTAB_VIEWER_GRID_TYPE.PRIVATE_EYE) {
      const defaultVisibleCellElement = getDefaultCells(this.props.crosstabWeightTypes).filter(
        (defCellDef, defCellIndex) => cellElementList[defCellIndex].isVisible,
      );
      const renderedColumnsLength = Math.ceil(
        horizontalEPP / defaultVisibleCellElement.length,
      );
      const lastRenderedColumn =
        horizontalPageNo + renderedColumnsLength < columnDefinitions.length
          ? horizontalPageNo + renderedColumnsLength
          : columnDefinitions.length;
      return columnDefinitions
        .slice(horizontalPageNo, lastRenderedColumn)
        .reduce(
          (headRow, columnDef, columnIndex) => [
            ...headRow,
            ...defaultVisibleCellElement.map((defCellDef, defCellIndex) =>
              renderCell(
                defCellDef,
                (columnIndex * defaultVisibleCellElement.length) + defCellIndex,
                columnIndex,
              ),
            ),
          ],
          [],
        );
    }

    if (viewerGridType === CROSSTAB_VIEWER_GRID_TYPE.TREND) {
      return tableData.crosstabPerStudy.map((crosstabPerStudy, cellIndex) =>
        renderCell(crosstabPerStudy[0].studyDescription, cellIndex),
      );
    }

    return columnDefinitions.map(renderCell);
  };

  const renderColumnsTopHeader = () => {
    const defaultVisibleCellElement = getDefaultCells(this.props.crosstabWeightTypes).filter(
      (defCellDef, defCellIndex) => cellElementList[defCellIndex].isVisible,
    );
    const renderedColumnsLength = Math.ceil(
      horizontalEPP / defaultVisibleCellElement.length,
    );
    const lastRenderedColumn =
      horizontalPageNo + renderedColumnsLength < columnDefinitions.length
        ? horizontalPageNo + renderedColumnsLength
        : columnDefinitions.length;
    const newColDefinitions = columnDefinitions
      .slice(horizontalPageNo, lastRenderedColumn)
      .map((column, index) => {
        let newLabel = column.label;
        for (const key in selectedKPIsTitle) {
          if (
            selectedKPIsTitle[key].trim() === column.label.trim() &&
            allSelectedKPIsInfo[key] &&
            allSelectedKPIsInfo[key].modeled
          ) {
            newLabel = `${String.fromCharCode(10020)} ${column.label}`;
          }
        }
        return (
          <th
            key={index}
            className="crosstabViewerGrid-sort-arrow-todo"
            data-tooltip
            aria-haspopup="true"
            title={`${column.label} ${
              column.isColumnLabelUpdated ? String.fromCharCode(185) : ''
            }`}
            colSpan={
              cellElementList.filter(({ isVisible }) => isVisible).length
            }
          >
            <div>
              {newLabel}
              <sup>{column.isColumnLabelUpdated ? '1' : ''}</sup>
            </div>
          </th>
        );
      });
    return newColDefinitions;
  };
  if (viewerGridType === CROSSTAB_VIEWER_GRID_TYPE.PRIVATE_EYE) {
    return (
      <thead>
        <tr>{renderColumnsTopHeader()}</tr>
        <tr>{renderRows()}</tr>
      </thead>
    );
  }

  return (
    <thead>
      <tr>{renderRows()}</tr>
    </thead>
  );
};

CrosstabViewerGridHeadRow.propTypes = {
  tableData: PropTypes.shape({}),
  columnDefinitions: PropTypes.arrayOf(PropTypes.object),
  viewerGridType: PropTypes.oneOf(Object.values(CROSSTAB_VIEWER_GRID_TYPE)),
  selectedDropdownColumn: PropTypes.number,
  cellElementList: PropTypes.arrayOf(PropTypes.object),
  onSort: PropTypes.func,
  renderHeadCell: PropTypes.func,
  horizontalPageNo: PropTypes.number,
  horizontalEPP: PropTypes.number,
};

export default CrosstabViewerGridHeadRow;
